
export const Header = ({
    description = "Delivering value through AI and data solutions"
}) => (
    // <></>
    <header className="bg-gray-200 text-gray-800 p-4 relative text-center">
        {/* <img src="/images/logo_256.png" className='h-16 absolute left-4 top-1/2 -translate-y-1/2 xs:hidden visible' /> */}
        <div className='cursor-pointer' onClick={() => {
            window.location.href = "/"
        }}>
            <h1 className="text-2xl font-bold">Berger Paint's Agentic AI</h1>
            <p className="text-sm mt-2 capitalize">{description}</p>
        </div>
    </header>
);